import axios from 'axios';

import { ErrorCodeType } from 'common/components/CopyMagic/CopyMagic.types';

const getErrorCode = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const errorCode: ErrorCodeType = error.response?.data?.code;
    return errorCode;
  }
  return '';
};

export default getErrorCode;
